import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object().shape({
  name: yup.string().required("Product name is required"),
  categories: yup
    .array()
    .of(yup.string().required())
    .min(1, "At least one category is required")
    .required("Category is required"),
  store_properties: yup
    .array()
    .min(1, "At least one store is required")
    .of(
      yup.object().shape({
        cost_price: yup.string().required("Cost price is required"),
        pricings: yup.array().of(
          yup.object().shape({
            price: yup.string().required("Selling price is required"),
            pricing_type_id: yup
              .string()
              .nullable()
              .required("Pricing type is required"),
          }),
        ),
      }),
    ),

  setup_duration: yup.boolean(),
  booking_config: yup.object().when("setup_duration", {
    is: true,
    then: yup.object().shape({
      duration_value: yup.string().required("Length of service is required"),
      capacity: yup.string().required("Available slot is required"),
      availability_slots: yup.object().shape({
        start_time: yup.string().required("Start time is required"),
        end_time: yup.string().required("End time is required"),
      }),
    }),
  }),
});

export const useValidation = ({ ...rest }) => {
  return useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      ...rest,
    },
  });
};
